import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from "./routes/ProtectedRoute";
import { initialRoutes } from "./routes/routes";
import MobileLayout from './MobileView/MobileLayout';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import Login from './pages/auth/Login.jsx'
import { mobileRoutes } from './routes/mobileRoutes.js';

const generateRoutes = (routes) => {
  return routes.map(({ type, component: Component, children, ...rest }) => (
    <Route
      key={rest.path}
      {...rest}
      element={
        <ProtectedRoute type={type} title={rest?.title} image={rest?.image} isMobile={rest?.isMobile}>
          <Component />
        </ProtectedRoute>
      }
    >
      {children?.length ? generateRoutes(children) : null}
    </Route>
  ));
};

// const App = () => (
//   <Routes>{generateRoutes(initialRoutes())}</Routes>
// );
const App = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  const isMobilePath = ["/trade", "/chart", "/history", "/alerts", "/mailBox", "/report", "/news", "/accounts", "/settings", "/quote"].includes(location.pathname);

  useEffect(() => {
    console.log(isMobile)
  }, [isMobile])


  return (
    <Routes>
      {isMobile ? (
        // <>
        //   {/* <Route path="*" element={<MobileLayout />} /> */}
        //   <Route path="*" element={<MobileLayout />} />
        // </>
          generateRoutes(mobileRoutes)
      ) : (
        generateRoutes(initialRoutes())
      )}
    </Routes>
  );
};



export default App;